<dashboard-dialog-frame [header]='addOrEditTitle()' [dialogRef]='dialogRef'>

	<div class="p-2 h-100 d-flex flex-column justify-content-between">
		<div class="d-flex flex-column gap-2">
			<common-text-field [field]="comment()"></common-text-field>
		</div>

		<div class="mt-3">
			<common-button-row [center]="true">
				<button class="btn btn-primary" #commentEditorBtn>{{buttonText()}}</button>
				<button class="btn btn-standard" (click)="form.resetAll()">Revert</button>
				<button class="btn btn-standard" (click)="dialogRef.close()">Cancel</button>
			</common-button-row>
		</div>
	</div>

</dashboard-dialog-frame>